export default __webpack_public_path__ + "static/media/pfp 3-min.8d638e44.png";